import type { IconSvgObject } from './types';

const TapeMeasureIcon: IconSvgObject = [
  ["path", { d: "M16 8.5C16 10.433 12.866 12 9 12C5.13401 12 2 10.433 2 8.5C2 6.567 5.13401 5 9 5C12.866 5 16 6.567 16 8.5Z", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M5 10C5 11.1046 6.79086 12 9 12V8C6.79086 8 5 8.89543 5 10Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M2 9V15.6667C2 17.5076 5.13401 19 9 19H22V12H9", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M18 19V16.5M14 19V16.5M10 19V16.5M6 18.5V16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default TapeMeasureIcon;
